(function () {
  // Run when DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordion);
  } else {
    initAccordion();
  }

  function initAccordion() {
    const container = document.querySelector('.product-faqs.faq-accordion');
    if (!container) return;

    const contentWrap = container.querySelector('.faq-content .metafield-rich_text_field');
    if (!contentWrap) {
      // nothing to parse; optionally could create empty UI
      return;
    }

    // Parse the metafield content into Q/A pairs:
    // - Treat a <p> that contains a <strong> (or <b>) as a question marker
    // - Its answer is all following sibling nodes until next question marker
    const nodes = Array.from(contentWrap.childNodes);
    const qas = [];
    let i = 0;
    while (i < nodes.length) {
      const node = nodes[i];
      // Skip non-element nodes unless they contain text
      if (isQuestionNode(node)) {
        const qText = extractTextFromQuestionNode(node).trim();
        // gather answer nodes
        const answerParts = [];
        let j = i + 1;
        while (j < nodes.length && !isQuestionNode(nodes[j])) {
          // include element text or text nodes
          const n = nodes[j];
          const txt = nodeText(n);
          if (txt.trim() !== '') answerParts.push(txt.trim());
          j++;
        }
        const aText = answerParts.join('\n\n').trim() || '—';
        qas.push({ question: qText, answer: aText });
        i = j;
      } else {
        i++;
      }
    }

    // If no Q/A pairs found, leave existing content intact (fail-safe)
    if (!qas.length) return;

    // Build accordion list
    const list = document.createElement('ul');
    list.className = 'faq-list';
    list.setAttribute('role', 'list');

    qas.forEach((qa, idx) => {
      const li = document.createElement('li');
      li.className = 'faq-item';
      // Use index for stable id
      const qId = `faq-q-${idx+1}`;
      const panelId = `faq-a-${idx+1}`;

      // Button (question)
      const btn = document.createElement('button');
      btn.className = 'faq-question';
      btn.type = 'button';
      btn.id = qId;
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', panelId);
      btn.innerHTML = `<span class="faq-q-text">${escapeHtml(qa.question)}</span>
                       <span class="faq-chevron" aria-hidden="true">▸</span>`;

      // Panel (answer)
      const panel = document.createElement('div');
      panel.id = panelId;
      panel.className = 'faq-answer';
      panel.setAttribute('role', 'region');
      panel.setAttribute('aria-labelledby', qId);
      panel.hidden = true;
      // Preserve simple formatting: convert double newlines to <p>, single newline to <br>
      panel.innerHTML = formatAnswerHtml(qa.answer);

      // Wire keyboard and click
      btn.addEventListener('click', () => toggleItem(li, btn, panel));
      btn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleItem(li, btn, panel); }
        if (e.key === 'ArrowDown') { e.preventDefault(); focusNext(idx); }
        if (e.key === 'ArrowUp') { e.preventDefault(); focusPrev(idx); }
      });

      // assemble li
      li.appendChild(btn);
      li.appendChild(panel);
      list.appendChild(li);
    });

    // Replace contentWrap with list
    const faqContentParent = container.querySelector('.faq-content');
    if (faqContentParent) {
      faqContentParent.innerHTML = ''; // remove raw metafield content
      faqContentParent.appendChild(list);
    }

    // ✅ Smooth mount: fade/slide in once accordion is ready
    container.classList.add('faq-mounted');

    // Controls: search and toggle-all
    const searchInput = container.querySelector('#faq-search');
    const toggleAllBtn = container.querySelector('#faq-toggle-all');

    if (searchInput) {
      searchInput.addEventListener('input', (e) => {
        const q = e.target.value.trim().toLowerCase();
        filterFaq(list, q);
      });
    }

    if (toggleAllBtn) {
      toggleAllBtn.addEventListener('click', () => {
        const anyCollapsed = Array.from(list.querySelectorAll('.faq-item')).some(li => li.querySelector('.faq-question').getAttribute('aria-expanded') === 'false');
        Array.from(list.querySelectorAll('.faq-item')).forEach(li => {
          const btn = li.querySelector('.faq-question');
          const panel = li.querySelector('.faq-answer');
          setOpenState(li, btn, panel, anyCollapsed);
        });
        toggleAllBtn.setAttribute('aria-pressed', String(anyCollapsed));
        toggleAllBtn.textContent = anyCollapsed ? 'Collapse all' : 'Expand all';
      });
    }

    // Deep linking: open if URL hash matches #faq-<n>
    const hash = (location.hash || '').replace('#','');
    if (hash.startsWith('faq-')) {
      const idx = parseInt(hash.replace('faq-',''), 10);
      if (!Number.isNaN(idx) && idx >= 1 && idx <= qas.length) {
        const targetBtn = list.querySelector(`#faq-q-${idx}`);
        const targetPanel = list.querySelector(`#faq-a-${idx}`);
        if (targetBtn && targetPanel) {
          setOpenState(targetBtn.closest('.faq-item'), targetBtn, targetPanel, true);
          // scroll into view with small offset
          setTimeout(()=> targetBtn.scrollIntoView({behavior:'smooth', block:'center'}), 120);
        }
      }
    }

    // Utilities
    function isQuestionNode(node) {
      if (!node) return false;
      if (node.nodeType === Node.ELEMENT_NODE) {
        const el = node;
        // A question node can be:
        // - <p> that contains a <strong> or <b>
        // - <hN> element
        if (/^(P|DIV|H1|H2|H3|H4|H5|H6)$/i.test(el.nodeName)) {
          if (el.querySelector && (el.querySelector('strong, b'))) return true;
          // Or if element itself is heading
          if (/^H[1-6]$/.test(el.nodeName)) return true;
          // Or strong is the only child text node
          if (el.firstChild && el.firstChild.nodeType === Node.TEXT_NODE && el.textContent.trim().endsWith('?')) return true;
        }
      }
      return false;
    }

    function extractTextFromQuestionNode(node) {
      if (!node) return '';
      if (node.nodeType === Node.ELEMENT_NODE) {
        // prefer strong/b
        const strong = node.querySelector && node.querySelector('strong, b');
        if (strong) return strong.textContent;
        // heading fallback
        if (/^H[1-6]$/.test(node.nodeName)) return node.textContent;
        // otherwise use trimmed text
        return node.textContent || '';
      }
      return String(node || '');
    }

    function nodeText(n) {
      if (!n) return '';
      if (n.nodeType === Node.TEXT_NODE) return n.textContent || '';
      if (n.nodeType === Node.ELEMENT_NODE) return n.textContent || '';
      return '';
    }

    function toggleItem(li, btn, panel) {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      // close other items (single-open accordion). If you want multi-open, comment out the close loop.
      Array.from(list.querySelectorAll('.faq-item')).forEach(other => {
        const obtn = other.querySelector('.faq-question');
        const opanel = other.querySelector('.faq-answer');
        if (obtn && opanel && other !== li) setOpenState(other, obtn, opanel, false);
      });

      setOpenState(li, btn, panel, !expanded);

      // ensure opened FAQ is visible
      if (!expanded) {
        setTimeout(() => {
          li.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 150);
      }

      // update URL hash (deep-link)
      if (!expanded) {
        history.replaceState(null, '', `#${panel.id.replace('a','faq-')}`);
      } else {
        // remove faq hash
        if ((location.hash || '').replace('#','').startsWith('faq-')) {
          history.replaceState(null, '', location.pathname + location.search);
        }
      }
    }

    function setOpenState(li, btn, panel, open) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      li.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { panel.hidden = false; } else { panel.hidden = true; }
    }

    function focusNext(currentIdx) {
      const buttons = Array.from(list.querySelectorAll('.faq-question'));
      const next = buttons[currentIdx + 1] || buttons[0];
      next.focus();
    }
    function focusPrev(currentIdx) {
      const buttons = Array.from(list.querySelectorAll('.faq-question'));
      const prev = buttons[currentIdx - 1] || buttons[buttons.length - 1];
      prev.focus();
    }

    function escapeHtml(str){
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }

    // Format the answer text into safe HTML paragraphs and links (basic)
    function formatAnswerHtml(raw) {
      // If raw looks like HTML (contains tags), trust it (it came from metafield paragraphs)
      const looksLikeHtml = /<\/?[a-z][\s\S]*>/i.test(raw);
      if (looksLikeHtml) return raw;
      // Otherwise, convert double newlines to <p> and single newlines to <br>
      const pieces = raw.split(/\n{2,}/).map(p => p.trim()).filter(Boolean);
      return pieces.map(p => `<p>${escapeHtml(p).replace(/\n/g,'<br>')}</p>`).join('');
    }

    // Simple filter: hide list items whose question+answer do not match search
    function filterFaq(listEl, query) {
      const items = Array.from(listEl.querySelectorAll('.faq-item'));
      const q = (query || '').trim().toLowerCase();
      items.forEach((li) => {
        const qtxt = (li.querySelector('.faq-q-text')?.textContent || '').toLowerCase();
        const atxt = (li.querySelector('.faq-answer')?.textContent || '').toLowerCase();
        const match = q === '' || qtxt.includes(q) || atxt.includes(q);
        li.style.display = match ? '' : 'none';
      });
    }
  } // initAccordion end
})(); // IIFE end

// FAQ: Combined Expand/Collapse All button
(function () {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initToggleAll);
  } else {
    initToggleAll();
  }

  function initToggleAll() {
    const container = document.querySelector('.product-faqs.faq-accordion');
    if (!container) return;

    const toggleBtn = container.querySelector('#faq-toggle-all');
    if (!toggleBtn) return;

    // Helper: find all faq items and their button/panel
    function getItems() {
      return Array.from(container.querySelectorAll('.faq-list .faq-item')).map(li => {
        const btn = li.querySelector('.faq-question');
        const panel = li.querySelector('.faq-answer');
        return { li, btn, panel };
      });
    }

    // No items -> disable button
    const items = getItems();
    if (!items.length) {
      toggleBtn.disabled = true;
      toggleBtn.setAttribute('aria-pressed', 'false');
      toggleBtn.setAttribute('aria-label', 'No FAQs available');
      return;
    }

    // Determine initial state: if any collapsed -> button shows Expand all. If all expanded -> Collapse all.
    function updateButtonLabel() {
      const itemsNow = getItems();
      const anyCollapsed = itemsNow.some(it => it.btn.getAttribute('aria-expanded') !== 'true');
      const text = anyCollapsed ? 'Expand all' : 'Collapse all';
      toggleBtn.querySelector('.faq-toggle-text').textContent = text;
      toggleBtn.setAttribute('aria-pressed', String(!anyCollapsed));
      toggleBtn.setAttribute('aria-label', text);
    }
    updateButtonLabel();

    // animation helpers: open/close with maxHeight transition
    function openPanel(panel, li) {
      if (!panel) return;
      panel.hidden = false;
      // measure
      panel.style.maxHeight = panel.scrollHeight + 'px';
      // clear after transition to allow natural height growth
      setTimeout(()=> {
        if (li.getAttribute('aria-expanded') === 'true') panel.style.maxHeight = 'none';
      }, 350);
    }
    function closePanel(panel) {
      if (!panel) return;
      // to animate close: set explicit height then to 0
      panel.style.maxHeight = panel.scrollHeight + 'px';
      // force repaint
      panel.getBoundingClientRect();
      panel.style.maxHeight = '0';
      // hide after transition
      setTimeout(()=> {
        panel.hidden = true;
        panel.style.maxHeight = '';
      }, 350);
    }

    // Set open/closed for a single item
    function setOpenStateSingle(item, open) {
      if (!item || !item.btn || !item.panel) return;
      item.btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      item.li.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) openPanel(item.panel, item.li); else closePanel(item.panel);
    }

    // Toggle all when button clicked
    toggleBtn.addEventListener('click', function () {
      const currentItems = getItems();
      const anyCollapsed = currentItems.some(it => it.btn.getAttribute('aria-expanded') !== 'true');
      // If any are collapsed -> Expand all. Otherwise Collapse all.
      currentItems.forEach(it => setOpenStateSingle(it, anyCollapsed));
      // update label and aria
      toggleBtn.setAttribute('aria-pressed', String(!anyCollapsed));
      toggleBtn.querySelector('.faq-toggle-text').textContent = anyCollapsed ? 'Collapse all' : 'Expand all';
      toggleBtn.setAttribute('aria-label', anyCollapsed ? 'Collapse all FAQs' : 'Expand all FAQs');

      // quick pulse effect to draw attention
      toggleBtn.classList.remove('pulse');
      // reflow to restart animation
      // eslint-disable-next-line no-unused-expressions
      void toggleBtn.offsetWidth;
      toggleBtn.classList.add('pulse');
      // clear pulse class after animation
      setTimeout(()=> toggleBtn.classList.remove('pulse'), 900);
    });

    // Keep button label updated if user opens/closes single items manually
    // (listen for clicks on question buttons)
    container.addEventListener('click', function (e) {
      const q = e.target.closest('.faq-question');
      if (q && container.contains(q)) {
        // delay to allow toggle logic in other script to update aria-expanded
        setTimeout(updateButtonLabel, 120);
      }
    });

    // Also handle keyboard open/close (space/enter) via keydown (to sync label)
    container.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        const q = e.target.closest('.faq-question');
        if (q && container.contains(q)) {
          setTimeout(updateButtonLabel, 120);
        }
      }
    });
  } // initToggleAll
})();
